import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getContainerStyle } from './util';
import GridItem from './GridItem';
import './index.less';

class GridContainer extends Component {

    static defaultProps = {
        rowGap: 16,
        colGap: 16,
    };

    render() {
        const {
            className,
            style,
            children,
            colGap,
            rowGap,
            griditems,
            ...restProps
        } = this.props;

        const wrapCls = classnames("grid-layout-container", className);
        const wrapStyle = Object.assign({}, getContainerStyle(rowGap, colGap), style);
        return (
            <div className={wrapCls} style={wrapStyle} {...restProps}>
                {Array.isArray(griditems) && griditems.length ? (griditems.map((item, index) => <GridItem key={index} {...item}>{ item?.render?.()}</GridItem>)):children}
            </div>
        );
    }
}

GridContainer.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    colGap: PropTypes.number,
    rowGap: PropTypes.number,
};

export default GridContainer;  